import companyPaymentsSlice from './companyPaymentsSlice'
export default companyPaymentsSlice.reducer
